import { BackendApiInstance } from "../config/Interceptor";
import Api from "./../config/Api";
export function getVehicleDetail(id,s,st) {
    if (id) {
        return BackendApiInstance.get(`${Api.getVehicleDetail}?idVehicle=${id}&s=${s}&st=${st}`);
    }
}
